// english
export default {
  find_password_back: '返回主页',
  find_password_title: '找回密码',

  find_password_email: '邮箱',
  find_password_email_placeholder: '请输入帐号绑定的邮箱',
  find_password_captcha: '验证码',
  find_password_captcha_placeholder: '请输入验证码',
  find_password_success_tip1: '重置密码链接，已成功发送到',
  find_password_success_tip2: '链接有效期为2小时，请及时操作以防泄漏',

  // reset
  find_password_reset_title: '重置密码',
  find_password_expired: '重置密码链接已过期',
  find_password_resend: '重新发送',
  find_password_new_password: '新密码',
  find_password_new_password_placeholder: '请输入新密码',
  find_password_confrim_password: '确认密码',
  find_password_confrim_password_placeholder: '请确认新密码',
  find_password_strong: '密码强度不够',
  find_password_equal: '两次输入的密码不一致',
  find_password_success_tip3: '重置密码成功',
};
